<template lang="jade">
  template(v-if="fdata.content.length === 0")
    .Message(class="Message--info")
      i.fa.fa-info(style="margin-right: 15px")
      .Message__content {{ fdata.noDataMessage || 'No data found' }}
  div(v-else)
    template(v-if="fdata.subtype")  
      ul.List(class="List--data")
        li.List__item(v-for="item in fdata.content"
                      tabindex="0")          
            div.Data
              div.Data__left
                template(v-if="item.image.src")
                  div.Data__image(":style"="item.image | backdrop")
              div.Data__body
                h2.Data__title {{ item.title.value }}
                div.Data__date {{ item.date.value | format }}
                div.Data__text {{ item.desc.value }}
                div.Data__actions
                  component("is"="type_buttonGroup" ":fdata"="item.buttons")
    template(v-else)
      table.Grid
        thead.Grid__head 
          tr.Grid__cols
            th.Grid__col(v-for="col in fdata.columns") {{ col }}
        tbody.Grid__body
          tr.Grid__rows(v-for="row in fdata.content")
            td.Grid__cell(v-for="cell in row"
                          v-bind:class="{'Grid__cell--actions': (cell.type === 'type_buttonGroup')}")
              template(v-if="cell.type === 'type_buttonGroup'")
                component(":is"="cell.type" ":fdata"="cell")
              template(v-else) {{ cell.value }}                      
    pager(":page.sync"="fdata.page"
          ":limit"="fdata.rowsPerPage"
          ":records"="fdata.totalRows")
</template>

<script>
import { DataTable } from 'src/services/resources'
import { workflow } from 'src/vuex/getters'
import { updateWorkflow } from 'src/vuex/actions'
import Moment from 'moment'
import _ from 'lodash'

const htmlToTypeImage = x => {
  switch (x.type) {
    case 'type_rawHtml':
      let img = /<img.*?src=['"](.*?)['"]/.exec(x.value)
      return img ? {type: 'type_image', src: img[1]} : x
    default:
      return x
  }
}

const Event = x => {
  let image, buttons
  let [title, date, desc, ...rest] = x
  if (rest.length > 1) {
    image = htmlToTypeImage(_.head(rest))
    buttons = _.last(rest)
  } else {
    image = {}
    buttons = _.head(rest)
  }
  return {type: 'event', title, date, desc, image, buttons}
}

const TYPES = {
  'EVENT': Event
}

const defmulti = x => {
  let type = _.head(x.currentFragmentId.split('.'))
  return _.has(TYPES, type) ? TYPES[type](x.content) : x.content
}

export default {
  data () {
    return {
      uid: this.$parent.uid
    }
  },

  props: {
    fdata: {
      type: Object,
      coerce (x) {
        if (x.content.length > 0) {
          let head = _.head(x.content)
          let cols = head.content
          let type = _.head(head.currentFragmentId.split('.'))
          x.subtype = _.has(TYPES, type) ? type : null
          x.columns = _.map(cols, x => _.get(x, 'label'))
          return _.set(x, 'content', _.map(x.content, defmulti))
        }
        return x
      },
      required: true
    }
  },

  vuex: {
    getters: {
      workflow
    },
    actions: {
      updateWorkflow
    }
  },

  watch: {
    'fdata.page': 'fetch'
  },

  filters: {
    format (val) {
      return Moment(val).format('DD/MM/YYYY')
    },
    backdrop (x) {
      return {
        'background-image': `url(${x.src})`,
        'width': '100%',
        'height': '100%',
        'background-repeat': 'no-repeat',
        'background-size': 'cover',
        'background-position': 'center center'
      }
    }
  },

  methods: {
    fetch () {
      DataTable.html(this.params, this.headers)
        .then(this.success)
        .catch(this.fail)
    },

    success (res) {
      let {content, id} = res.data
      let q = ['uid', this.uid]
      let workflow = _.find(this.workflow, q)
      let idx = _.findIndex(this.workflow, q)
      this.updateWorkflow(_.merge(workflow, {fid: id}), idx)
      let d = this.parse(content)
                  .map(defmulti)
      this.$set('fdata.content', d)
    },

    parse (data) {
      return _.map(data, x => {
        x = (x.type !== 'type_contentGroup') ? x : _.set(x, 'type', x.format === undefined || x.format === 'default' ? x.class : x.format)
        return _.isNil(x.content) ? x : _.set(x, 'content', this.parse(x.content))
      })
    }
  },

  computed: {
    headers () {
      let header = _.find(this.workflow, ['uid', this.uid])
      return {
        headers: {
          'X-SITEID': header.sid,
          'X-FINGERPRINT': header.fingerprint
        }
      }
    },

    params () {
      return { savelistId: this.fdata.savelistId,
               page: this.fdata.page,
               rowsPerPage: this.fdata.rowsPerPage }
    }
  },

  components: {
    pager: require('src/components/paginators/basic')
  },

  ready () {}
}
</script>



// WEBPACK FOOTER //
// dataList.vue?edb5b5ce